import moment from 'moment';
import { useMemo, useRef, useState } from "react";
import Card from "../../../componentes/contenedores/Card";
import Page from "../../../componentes/plantilla/Page";
import { useContextEmpleado } from "../../../contexto/empleado/EmpleadoContext";
import { useContextUsuario } from "../../../contexto/usuario/UsuarioContext";
import TablaEditarLotes from "./TablaEditarLote";

const HomeEditarLotes = () => {
    const { listaProductos, listaTiposProductos } = useContextEmpleado();
    const { token } = useContextUsuario();
    const refTabla = useRef(null);
    const [fechaInicio, setFechaInicio] = useState(
        moment().subtract(1, "days").format("YYYY-MM-DD")
    );
    const [fechaFin, setFechaFin] = useState(moment().format("YYYY-MM-DD"));
    const [estadoLoteFiltro, setEstadoLoteFiltro] = useState("Todos");
    const [categoriaFiltro, setCategoriaFiltro] = useState("");
    const [productoFiltro, setProductoFiltro] = useState("");
    const [panelAbierto, setPanelAbierto] = useState(false);
    const [resetKey, setResetKey] = useState(0);

    const datos = {
        titulo: {
            titulo: "Edición de lote por producto",
            url: "/app/admin/lotes/gestionar",
            tituloUrl: "Lotes",
            nombreUrl: "Editar",
        },
    };

    const estadosLote = [
        { value: "Disponible", label: "Disponible" },
        { value: "Agotado", label: "Agotado" },
        { value: "Todos", label: "Todos" },
    ];

    const handleFiltrar = () => {
        setPanelAbierto(false);
    };

    const handleReset = () => {
        setFechaInicio(moment().format("YYYY-MM-DD"));
        setFechaFin(moment().format("YYYY-MM-DD")); 
        setEstadoLoteFiltro("Todos");
        setCategoriaFiltro("");
        setProductoFiltro("");
        setPanelAbierto(false);
        setResetKey(prev => prev + 1);
    };

    const lotesAplanados = useMemo(() => {
        const terminoBusqueda = productoFiltro ? productoFiltro.toLowerCase().trim() : '';
        const palabrasClaveBusqueda = terminoBusqueda.split(/\s+/).filter(word => word.length > 0);

        // 1. Aplanar todos los lotes y adjuntar datos del producto
        let lotes = listaProductos.flatMap(producto => {
            return (producto.lotes || []).map(lote => {
                const inventariosAsignados = lote.loteinventarios ? lote.loteinventarios.length : 0;
                const ultimaAsignacion = lote.loteinventarios && lote.loteinventarios.length > 0
                    ? lote.loteinventarios.reduce((maxDate, inv) => {
                        return lote.fecha_ingreso > maxDate ? lote.fecha_ingreso : maxDate;
                    }, lote.fecha_ingreso)
                    : 'N/A';

                return {
                    productoId: producto.id,
                    productoNombre: producto.nombre,
                    productoCodigo: producto.codigo,
                    productoTipoId: producto.productoTipoId,
                    productoCompleto: producto,

                    IdLote: lote.id,
                    NombreLote: lote.nombre_lote,
                    FechaIngreso: lote.fecha_ingreso,
                    EstadoLote: lote.estado,
                    CantidadTotal: lote.cantidad,
                    ExistenciaTotal: lote.existencia,
                    InventariosAsignados: inventariosAsignados,
                    UltimaAsignacion: ultimaAsignacion,
                };
            });
        });

        // 2. Aplicar todos los filtros en un solo paso
        const lotesFiltrados = lotes.filter(lote => {
            let pasaFiltro = true;

            if (estadoLoteFiltro !== "Todos") {
                pasaFiltro = pasaFiltro && (lote.EstadoLote === estadoLoteFiltro);
            }

            if (categoriaFiltro !== '') {
                const productoIdString = lote.productoTipoId ? String(lote.productoTipoId) : '';
                pasaFiltro = pasaFiltro && (productoIdString === categoriaFiltro);
            }

            if (palabrasClaveBusqueda.length > 0) {
                const textoProducto = (lote.productoNombre + " " + lote.productoCodigo).toLowerCase();
                const pasaProducto = palabrasClaveBusqueda.every(palabra => textoProducto.includes(palabra));
                pasaFiltro = pasaFiltro && pasaProducto;
            }

            if (fechaInicio && fechaFin) {
                // Convertimos la fecha de ingreso del lote a un objeto moment
                const fechaLote = moment(lote.FechaIngreso);

                // Verificamos si está entre inicio y fin
                // 'day' hace que ignore las horas (solo compara fechas)
                // '[]' hace que la comparación sea inclusiva (>= y <=)
                const estaEnRango = fechaLote.isBetween(fechaInicio, fechaFin, 'day', '[]');

                pasaFiltro = pasaFiltro && estaEnRango;
            }

            return pasaFiltro;
        });

        return lotesFiltrados;
    }, [listaProductos, estadoLoteFiltro, categoriaFiltro, productoFiltro, fechaFin, fechaInicio, listaTiposProductos]);

    const renderFilterPanel = () => (
        <div className="mb-4 d-flex justify-content-end">
            <div className="position-relative">
                <button
                    className={`btn ${panelAbierto ? "btn-danger" : "btn-primary"} d-flex justify-content-between align-items-center`}
                    onClick={() => setPanelAbierto(!panelAbierto)}
                    style={{
                        borderRadius: "6px",
                        padding: "6px 12px",
                        fontSize: "0.9rem",
                        minWidth: "140px",
                    }}
                >
                    <span className="d-flex align-items-center">
                        <i className="fas fa-filter mx-2"></i>
                        Filtros
                    </span>
                    <i className={`fas fa-chevron-${panelAbierto ? "up" : "down"}`}></i>
                </button>

                {panelAbierto && (
                    <div
                        className="position-absolute top-100 mt-2 bg-body border border-secondary-subtle text-body shadow"
                        style={{
                            minWidth: "280px",
                            right: 0,
                            borderRadius: "10px",
                            backgroundColor: "#fff",
                            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                            padding: "15px",
                            zIndex: 1050,
                        }}
                    >
                        {/* Fecha de Inicio */}
                        <div className="mb-3">
                            <label className="form-label">Fecha Inicio</label>
                            <input
                                type="date"
                                className="form-control form-control-sm"
                                value={fechaInicio}
                                onChange={(e) => setFechaInicio(e.target.value)}
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Fecha Fin</label>
                            <input
                                type="date"
                                className="form-control form-control-sm"
                                value={fechaFin}
                                onChange={(e) => setFechaFin(e.target.value)}
                            />
                        </div>
                        {/* Filtro de Producto */}
                        <div className="form-group mb-3">
                            <label htmlFor="filtroProductoInput" className="form-label fw-bold">Producto (Nombre/Código)</label>
                            <input
                                id="filtroProductoInput"
                                type="text"
                                className="form-control form-control-sm"
                                placeholder="Buscar por nombre o código"
                                value={productoFiltro}
                                onChange={(e) => setProductoFiltro(e.target.value)}
                            />
                        </div>

                        {/* Filtro de Estado del Lote */}
                        <div className="form-group mb-3">
                            <label htmlFor="filtroEstadoLoteSelect" className="form-label fw-bold">Estado del Lote</label>
                            <select
                                id="filtroEstadoLoteSelect"
                                className="form-control form-control-sm"
                                value={estadoLoteFiltro}
                                onChange={(e) => setEstadoLoteFiltro(e.target.value)}
                            >
                                {estadosLote.map((estado) => (
                                    <option key={estado.value} value={estado.value}>
                                        {estado.label}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Filtro de Categoría */}
                        <div className="form-group mb-3">
                            <label htmlFor="filtroCategoriaSelect" className="form-label fw-bold">Categoría</label>
                            <select
                                id="filtroCategoriaSelect"
                                className="form-control form-control-sm"
                                value={categoriaFiltro}
                                onChange={(e) => setCategoriaFiltro(e.target.value)}
                            >
                                <option value="">Todas las categorías</option>
                                {listaTiposProductos?.map((tipo) => (
                                    <option key={tipo.id} value={String(tipo.id)}>
                                        {tipo.nombre}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="d-flex justify-content-end">
                            <button className="btn btn-sm btn-primary mx-2" onClick={handleFiltrar}>
                                <i className="fas fa-filter mx-1"></i> Filtrar
                            </button>
                            <button className="btn btn-sm btn-secondary" onClick={handleReset}>
                                <i className="fas fa-sync-alt mx-1"></i> Reset
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );

    return (
        <Page datos={datos}>
            <div ref={refTabla}>
                <Card titulo="Editar Lotes">
                    {renderFilterPanel()}
                    <TablaEditarLotes
                        key={resetKey}
                        datos={lotesAplanados}
                    />
                </Card>
            </div>
        </Page>
    );
};

export default HomeEditarLotes;